<template>
    <v-row>
        <v-col
            md="12"
            v-for="index in 1"
            :key="index"
        >
            <v-card elevation="5" class="pa-md-4">
                <v-row>
                    <v-col
                        md="11"
                    >
                        <h2 class="display-1 font-weight-normal">Serrallo</h2>
                    </v-col>
                    <v-col
                        md="1"
                        class="ml-md-n6"
                    >
                        <v-row>
                            <v-col
                                md="12"
                            >
                                <v-btn
                                    fab
                                    x-small
                                    color="red"
                                    outlined
                                    class="backFlipBtn" 
                                    @click="updateValue(false)"
                                >
                                    <v-icon>
                                        mdi-axis-z-rotate-clockwise
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row class="mt-2">
                    <v-col
                        md="6"
                        v-for="index in 4"
                        :key="index"
                    >
                        <v-row>
                            <v-col
                                md="12"
                            >
                                <h4 class="font-weight-thin">Objetivo 1</h4>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <v-col
                                md="6"
                                class="pt-md-8"
                            >
                                <div class="text-center">
                                    <v-progress-circular
                                        :rotate="0"
                                        :size="100"
                                        :width="5"
                                        :value="11"
                                        color="pink"
                                    >
                                        11
                                    </v-progress-circular>
                                </div>
                            </v-col>
                            <v-col
                                md="6"
                                class="pt-md-8"
                            >
                                <div class="text-center">
                                    <v-progress-circular
                                        :rotate="0"
                                        :size="100"
                                        :width="5"
                                        :value="11"
                                        color="pink"
                                    >
                                        11
                                    </v-progress-circular>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: [
            'value'
        ],
        name : "ShopAdministrationState",
        methods : {
            updateValue: function (value) {
                this.$emit('input', value);
            }
        }
    }
</script>